module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av515-a70d998885b910cf5928a1f056455f4c.jpg";